import React, { memo } from 'react';
import cls from './Option.module.css';
import classNames from 'classnames';
import { Estimate } from '../../../../entities/task/model/types/tasks';

type TEstimate = {
    id: number;
    title: string;
};

interface EstimateOptionProps {
    estimates: Estimate[];
    projectId: number;
    onClick: (value: Estimate, projectId: number) => void;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    projectName: string;
}

export const EstimateOption = memo(
    ({ estimates, onClick, setIsOpen, projectName, projectId }: EstimateOptionProps) => {
        const handleClick = (event: React.MouseEvent, value: Estimate) => {
            event.stopPropagation();
            if (value.id) {
                onClick({ ...value, name: `${projectName} / ${value.name}` }, projectId);
                setIsOpen(false);
            }
        };

        if (!estimates) {
            return null;
        }

        return (
            <>
                {estimates?.map((estimate) => {
                    return (
                        <li
                            key={estimate.id}
                            className={classNames(cls.option)}
                            onClick={(e) => handleClick(e, estimate)}
                        >
                            <span className={classNames(cls.optionTitle, [cls.optionSpan])}>
                                {estimate.name}
                            </span>
                        </li>
                    );
                })}
            </>
        );
    }
);
